import React, { useState, useRef } from 'react';

const AdminSendNewsletter = ({ password }) => {
  const [subject, setSubject] = useState('');
  const [content, setContent] = useState('');
  const [preview, setPreview] = useState('');
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef();

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (event) => {
      setContent(event.target.result);
      setPreview('');
    };
    reader.readAsText(file);
  };

  const handlePreview = () => {
    setPreview(content);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('');
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/send_newsletter', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-admin-password': password
        },
        body: JSON.stringify({ subject, content })
      });
      if (res.status === 401) {
        setError('Incorrect admin password.');
      } else if (!res.ok) {
        setError('Failed to send newsletter.');
      } else {
        setStatus('Newsletter sent and archived successfully!');
        setSubject('');
        setContent('');
        setPreview('');
        if (fileInputRef.current) fileInputRef.current.value = '';
      }
    } catch (err) {
      setError('Error sending newsletter.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 700, margin: '2rem auto', padding: 20 }}>
      <h2>Send Newsletter</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Subject *</label>
          <input
            type="text"
            value={subject}
            onChange={e => setSubject(e.target.value)}
            style={{ width: '100%', padding: 8, marginBottom: 12 }}
            required
          />
        </div>
        <div className="form-group">
          <label>Content (HTML or Markdown) *</label>
          <textarea
            value={content}
            onChange={e => setContent(e.target.value)}
            rows={10}
            style={{ width: '100%', padding: 8, marginBottom: 12, fontFamily: 'monospace' }}
            required
          />
        </div>
        <div className="form-group">
          <label>Upload .md or .html file</label>
          <input
            type="file"
            accept=".md,.html,.txt"
            onChange={handleFileUpload}
            ref={fileInputRef}
            style={{ marginBottom: 12 }}
          />
        </div>
        <button type="button" onClick={handlePreview} style={{ marginRight: 12 }}>
          Preview
        </button>
        <button type="submit" disabled={loading}>
          {loading ? 'Sending...' : 'Send Newsletter'}
        </button>
      </form>
      {status && <div style={{ color: 'green', marginTop: 16 }}>{status}</div>}
      {error && <div style={{ color: 'red', marginTop: 16 }}>{error}</div>}
      {preview && (
        <div style={{ marginTop: 32 }}>
          <h3>Preview</h3>
          <div style={{ border: '1px solid #ccc', padding: 16, background: '#fafafa' }}
            dangerouslySetInnerHTML={{ __html: preview }}
          />
        </div>
      )}
    </div>
  );
};

export default AdminSendNewsletter; 